import BackgroundImageProps from "../BackgroundGradientProps.interface";

import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

export default (props: BackgroundImageProps): any => {
    const settings = useSelector(state => state.settings.content);
    const elementRef = useRef<any>(null);

    useEffect(() => {
        if (elementRef.current && settings) {
            if (props.content.primaryColor) {
                elementRef.current.style.setProperty("--gradient-primary-color", props.content.primaryColor);
            }

            if (props.content.secondaryColor) {
                elementRef.current.style.setProperty("--gradient-secondary-color", props.content.secondaryColor);
            }

            if (typeof(props.content.angle) !== "undefined") {
                elementRef.current.style.setProperty("--gradient-angle", `${props.content.angle}deg`);
            }
        }
    }, [elementRef, settings]);

    return elementRef;
};